// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-subheader-search .m-checkbox.m-checkbox--state-brand > span::after {\n  border: solid #fff;\n}\n@media (max-width: 678px) {\n.m-form .header-content .filters-list .m-input-icon {\n    width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
